import React from 'react';
import Tooltip from '@influitive/secret-garden/lib/tooltip';

export default ({ id, zIndex = 1005 }) => (
  <Tooltip id={id} clickable={true} place="bottom" zIndex={zIndex}>
    This can't be previewed in Lens Mode.
  </Tooltip>
);
